import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import {
    NotificationClientService,
    NotificationType
} from "../../../../../../services/basics/notification-client.service";
import { ValidationActivation, ValidationTypeEnum } from "../../../../../../client-validation-system/validations.models";
import { EntityValidationsService, ClientSideValidator } from "../../../../../../client-validation-system/validations-service";
import { DataGrid } from "../../../../../components/data-grid/data-grid";
import { SubtasksService } from "../../../../../../services/subtasks/subtasks.service";
import { RfiTemplateCategoryEnum, SaveSubtaskTypeRequest } from "../../../../../../models/vetting/vetting.models";
import { ValidationsClientService } from "../../../../../../services/validations/validations-client.service";

@autoinject
@transient()
export class AddSubtaskTypeDialog {

    public dataGrid: DataGrid;
    public validator: ClientSideValidator;
    public isActive: boolean = true;
    public isDefault: boolean = false;
    public isCloseConversation: boolean = false;
    public usedForConsolidationEmail: boolean = false;
    public excludeFromHome: boolean = false;
    public rfiTemplateCategoryId: RfiTemplateCategoryEnum = RfiTemplateCategoryEnum.VET;
    public subtaskTypeId: number;
    public template: string;
    public name: string;
    public isCustomerRfi: boolean = false;

    constructor(private dialogClientService: DialogClientService,
        private subtasksService: SubtasksService,
        private notificationService: NotificationClientService,
        private validationsClientService: ValidationsClientService,
        private entityValidationsService: EntityValidationsService) {
    }

    async activate(model) {
        this.dataGrid = model.dataGrid;
        this.subtaskTypeId = model.subtaskTypeId;
        if (this.subtaskTypeId) {
            const subtaskType = await this.subtasksService.getSubtaskType(this.subtaskTypeId);
            this.template = subtaskType.template;
            this.name = subtaskType.name;
            this.isActive = subtaskType.isActive;
            this.isDefault = subtaskType.isDefault;
            this.isCloseConversation = subtaskType.isCloseConversation;
            this.usedForConsolidationEmail = subtaskType.usedForConsolidationEmail;
            this.excludeFromHome = subtaskType.excludeFromHome;
            this.rfiTemplateCategoryId = subtaskType.rfiTemplateCategoryId;
            this.isCustomerRfi = subtaskType.isCustomerRfi;
        }

        const rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "SubtaskType",
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: "Name is required",
                parameters: null, property: "name",
                validationType: ValidationTypeEnum.Required
            }]
        };
        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);
    }

    close() {
        this.dialogClientService.hide();
    }

    save() {
        const subtaskTypeRequest: SaveSubtaskTypeRequest = {
            subtaskTypeId: this.subtaskTypeId,
            name: this.name,
            isActive: this.isActive,
            isDefault: this.isDefault,
            isCloseConversation: this.isCloseConversation,
            usedForConsolidationEmail: this.usedForConsolidationEmail,
            excludeFromHome: this.excludeFromHome,
            template: this.template,
            rfiTemplateCategoryId: this.rfiTemplateCategoryId,
            isCustomerRfi: this.isCustomerRfi
        };

        return new Promise<void>((resolve, reject) => {
            this.validator.validate().then(validationResponse => {
                if (validationResponse.valid) {
                    this.subtasksService.saveSubtaskType(subtaskTypeRequest)
                        .then(response => {
                            if (response.validationResult && response.validationResult.hasError) {
                                this.validationsClientService.showValidationErrors(response.validationResult);
                            } else {
                                if (this.dataGrid) {
                                    this.dataGrid.reloadData();
                                }
                                this.notificationService.show(`Your subtaks type has been ${this.subtaskTypeId > 0 ? 'saved' : 'added'} Successfully`, "", NotificationType.Success);
                                this.dialogClientService.hide();
                            }
                            resolve();
                        })
                        .catch(response => {
                            if (response.validationResult && response.validationResult.hasError) {
                                this.validationsClientService.showValidationErrors(response.validationResult);
                            } else {
                                this.notificationService.show("Error saving subtask type", "", NotificationType.Error);
                            }
                            reject();
                        });
                } else {
                    reject();
                }
            });
        });
    }
}
